// @flow
import {
    LIVE_AUCTION_LOADED,
    type LIVE_AUCTION_LOADED_ACTION,
    LIVE_AUCTION_OPENED,
    type LIVE_AUCTION_OPENED_ACTION,
    LOAD_LIVE_CATALOG_STATUS_SUCCESS,
} from './actions';
import type { ActionWithPayload } from '../../types/redux';
import { createSelector } from 'reselect';
import { handleActions } from 'redux-actions';

/* reducer */
const DEFAULT_STATE = {
    byId: {},
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export const reducer = handleActions(
    {
        [LIVE_AUCTION_LOADED]: (state: State, action: LIVE_AUCTION_LOADED_ACTION) => {
            const { catalogId, serverId } = action.payload;

            if (Boolean(catalogId) && Boolean(serverId)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [catalogId]: serverId,
                    },
                };
            }
            return state;
        },
        [LIVE_AUCTION_OPENED]: (state: State, action: LIVE_AUCTION_OPENED_ACTION) => {
            const { catalogId, serverId } = action.payload;

            if (Boolean(catalogId) && Boolean(serverId)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [catalogId]: serverId,
                    },
                };
            }
            return state;
        },
        [LOAD_LIVE_CATALOG_STATUS_SUCCESS]: (
            state: State,
            action: ActionWithPayload<{ catalogId: number, shim: number }>
        ) => {
            const { catalogId, shim } = action.payload;

            if (Boolean(catalogId) && Boolean(shim)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [catalogId]: shim,
                    },
                };
            }
            return state;
        },
    },
    DEFAULT_STATE
);

/* SELECTORS */
const stateSelector = state => state.shim;
const idSelector = (state, id) => id;

const byIdSelector = createSelector(stateSelector, state => state.byId);

export const getCatalogShim = createSelector([byIdSelector, idSelector], (byId, id) => {
    const shim = byId[id];
    if (shim > 0) {
        return shim;
    } else {
        return 0;
    }
});
